export default __webpack_public_path__ + "static/dont-position-30cedcbf49d6fe89189910f99bebc68a.png";